import Swiper, {Autoplay, EffectFade, Pagination, Navigation} from 'swiper';
import SWIPER_CLASS_NAMES from '../constants/swiper';

Swiper.use([Autoplay, EffectFade, Pagination, Navigation]);

const selectors = {
  slider: '.js-testimonials-slider',
  pagination: '.js-testimonials-pagination',
};

const testimonialsSlider = () => {
  const container = document.querySelector(selectors.slider);

  if (!container) return;

  const slider = new Swiper(container, {
    slidesPerView: 1,
    effect: 'fade',
    loop: true,

    fadeEffect: {
      crossFade: true,
    },

    autoplay: {
      delay: 7000,
    },

    pagination: {
      el: selectors.pagination,
      bulletClass: SWIPER_CLASS_NAMES.bulletClass,
      bulletActiveClass: SWIPER_CLASS_NAMES.bulletActiveClass,
      clickable: true,
    },

    navigation: {
      nextEl: '.c-swiper-navigation--next',
      prevEl: '.c-swiper-navigation--prev',
      disabledClass: 'c-swiper-navigation--disable',
    },
  });

  return slider;
};

export default testimonialsSlider;
